import EditorWorkspacePage from "./EditorWorkspacePage";

export default function GuidePage() {
  return <EditorWorkspacePage initialTab="guide" />;
}
